<template>
    <v-flex v-if="sponsorLists.length > 0 || canEditSponsor" class="sponsors__card ma-2">
        <v-layout>
            <v-flex xs12>
                <v-list-tile>
                    <v-flex tag="h2">{{sponsorTitle}}
                        <v-btn
                            v-if="canEditSponsor"
                            class="more_option"
                            @click="showDialog"
                            data-qe-id="sponsor-edit_btn"
                            icon
                            id="show_dialog_unittest">
                            <i class="fas fa-pencil-alt"></i>
                        </v-btn>
                    </v-flex>

                </v-list-tile>

            </v-flex>
        </v-layout>
        <sponsor-card :dialog-state="dialogState"></sponsor-card>
    </v-flex>
</template>

<script>
  import SponsorCard from "../SponsorCard/SponsorCard";
  import { mapGetters } from "vuex";
  import { storeGetters } from "../../../store/storeGetters.constant";
  import { routerNames } from "../../appCommon.constants";
  import sponsorsConstants from "./sponsors.constant";
  import { capitalizedString } from "../../../common/utils/utils";

  export default {
    name: "Sponsors",
    data: () => {
      return {
        routerNames,
        sponsorsConstants,
        dialogState: {
          isVisible: false,
          dialogOpen: false,
        },
      };
    },
    components: {
      SponsorCard,
    },
    methods: {
      showDialog() {
        this.dialogState.isVisible = true;
      },
    },
    computed: {
      ...mapGetters({
        canEditSponsor: `sponsor/${storeGetters.canEditSponsor}`,
        sponsorLists: `sponsor/${storeGetters.sponsorLists}`,
      }),
      sponsorTitle() {
        return `${capitalizedString(this.$route.name)} ${sponsorsConstants.SPONSORS}`;
      },
    },
  };
</script>

<style lang="scss">
  @import "../../../common/styles/_colors.scss";

  .sponsors__card {
    border: 1px solid $ypo-medium-gray;
    border-radius: 4px;

    .v-list__tile {
      padding: 0px;
      min-height: inherit;
    }
  }
</style>
